export default __webpack_public_path__ + "static/8-00b6ffb8f9ac784c7474addf08a0c53f.webp";